import { render, staticRenderFns } from "./unloadDetail.vue?vue&type=template&id=623c715e&scoped=true&"
import script from "./unloadDetail.vue?vue&type=script&lang=js&"
export * from "./unloadDetail.vue?vue&type=script&lang=js&"
import style0 from "./unloadDetail.vue?vue&type=style&index=0&id=623c715e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623c715e",
  null
  
)

export default component.exports